export default __webpack_public_path__ + "static/media/push30.5bf852ff.gif";